import * as yup from 'yup';

import store from 'redux/store';
import { selectSubEventsByMainEventLookupId } from 'components/EventRegistration/redux/selectors';

export const oSchema = yup.object({
  subEvents: yup.array().min(1, 'Please select at least one event.'),
});

export const fnBuildInitialValues = (sLookupId = '') => {
  if (!sLookupId) {
    return {
      subEvents: [],
    };
  }

  const aSubEventsInCart = selectSubEventsByMainEventLookupId(sLookupId)(
    store.getState()
  );

  return {
    subEvents: aSubEventsInCart.map(
      (oSubEvent) => oSubEvent.oDetails.oEvent.LOOKUPID
    ),
  };
};

export const sFormId = 'multiLevelEventDetailsForm';
